module.exports.version = 'v11.8.3-7a8120dc';
